import { apiFetch, apiUpload } from '@/lib/api';

export interface AppUser {
  id: number;
  email: string;
  username: string | null;
  role_id: number;
  is_subscribed: boolean;
  is_active: boolean;
  profile: Record<string, unknown> | null;
  created_at: string;
}

export interface AppUsersPage {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  data: AppUser[];
}

export const ROLE_NAME: Record<number, string> = {
  1: 'systemadmin',
  2: 'user',
  3: 'admin',
  5: 'Normal User',
  7: 'Subscribe User',
};

export function listAppUsers(p: {
  page: number;
  pageSize: number;
  q?: string;
  role_id?: number;
  status?: string;
}): Promise<AppUsersPage> {
  const qs = new URLSearchParams({ page: String(p.page), pageSize: String(p.pageSize) });
  if (p.q) qs.set('q', p.q);
  if (p.role_id != null) qs.set('role_id', String(p.role_id));
  if (p.status) qs.set('status', p.status);
  return apiFetch<AppUsersPage>(`/users-management/users?${qs}`);
}

export function updateAppUser(
  id: number,
  body: { role_id?: number; is_subscribed?: boolean; is_active?: boolean; profile?: Record<string, unknown> },
): Promise<AppUser> {
  return apiFetch<AppUser>(`/users-management/users/${id}`, { method: 'PATCH', body: JSON.stringify(body) });
}

export function deleteAppUser(id: number): Promise<void> {
  return apiFetch(`/users-management/users/${id}`, { method: 'DELETE' });
}

// Upload a user's QR image to the shared attachments endpoint. Mirrors the iOS
// app's call (owner_type=flyer, attachment_type=qr_code, owner_id=user_qr_<id>)
// so admin + app QR uploads land in the same qr/<owner_id>/ namespace.
// The flyer-shape response returns { file_url }.
export async function uploadQrCode(userId: number, file: File): Promise<string> {
  const form = new FormData();
  form.append('owner_type', 'flyer');
  form.append('owner_id', `user_qr_${userId}`);
  form.append('attachment_type', 'qr_code');
  form.append('file', file);
  const res = await apiUpload<{ file_url: string }>('/attachments', form);
  return res.file_url;
}
